import React from 'react';
import './ScrollToTopButton.css';

const ScrollToTopButton = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'  // Smooth scroll animation
    });
  };

  return (
    <div className="scroll-to-top">
      <button onClick={handleScrollToTop}>
        ↑
      </button>
    </div>
  );
};

export default ScrollToTopButton;
